import _slicedToArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
import n, { useEffect as i, Children as r, isValidElement as a, cloneElement as o, useReducer as g, useRef as d } from "react";
import { isFragment as s } from "react-is";

function c(e, t) {
  var n = getComputedStyle(t);
  if (!n) return;
  var i = e === p.Horizontal ? t.clientWidth : t.clientHeight;
  return 0 !== i ? (e === p.Horizontal ? i -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) : i -= parseFloat(n.paddingTop) + parseFloat(n.paddingBottom), i) : void 0;
}

function l(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  i(function () {
    return window.addEventListener(e, t), function () {
      return window.removeEventListener(e, t);
    };
  }, [e, t].concat(_toConsumableArray(n)));
}

!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if (e && "undefined" != typeof document) {
    var i = document.head || document.getElementsByTagName("head")[0],
        r = document.createElement("style");
    r.type = "text/css", "top" === n && i.firstChild ? i.insertBefore(r, i.firstChild) : i.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}("/* === Main Container === */\n.__dbk__container {\n  height: 100%;\n  width: 100%;\n\n  display: flex;\n  overflow: hidden;\n}\n\n.__dbk__container.Horizontal {\n  flex-direction: row;\n}\n\n.__dbk__container.Vertical {\n  flex-direction: column;\n}\n/* ====== */\n\n/* === Wrapper for each child element === */\n.__dbk__child-wrapper {\n  height: 100%;\n  width: 100%;\n}\n/* ====== */\n\n/* === Gutter === */\n.__dbk__gutter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* .__dbk__gutter > div {\n  background: red;\n} */\n.__dbk__gutter.Horizontal {\n  height: 100%;\n  padding: 0 2px;\n  flex-direction: column;\n}\n.__dbk__gutter.Horizontal:hover {\n  cursor: col-resize;\n}\n\n.__dbk__gutter.Vertical {\n  width: 100%;\n  padding: 2px 0;\n  flex-direction: row;\n}\n.__dbk__gutter.Vertical:hover {\n  cursor: row-resize;\n}\n\n.__dbk__gutter.Light {\n  background: #EDF0EF;\n}\n.__dbk__gutter.Light:hover > .__dbk__dragger {\n  background: #76747B;\n}\n\n.__dbk__gutter.Dark {\n  background: #020203;\n}\n.__dbk__gutter.Dark:hover > .__dbk__dragger {\n  background: #9995A3;\n}\n/* ====== */\n\n/* === Gutter's Dragger === */\n.__dbk__dragger {\n  border-radius: 2px;\n}\n\n.__dbk__dragger.Horizontal {\n  width: 4px;\n  height: 24px;  \n}\n\n.__dbk__dragger.Vertical {\n  width: 24px;\n  height: 4px;  \n}\n\n.__dbk__dragger.Light {\n  background: #A6ACB5;\n}\n\n.__dbk__dragger.Dark {\n  background: #434252;\n}\n/* ====== */");
var u = n.forwardRef(function (_ref, o) {
  var t = _ref.className,
      n = _ref.theme,
      i = _ref.draggerClassName,
      _ref$direction = _ref.direction,
      r = _ref$direction === void 0 ? p.Vertical : _ref$direction,
      a = _ref.onMouseDown;
  var g = "__dbk__gutter ".concat(r, " ").concat(t || n),
      d = "__dbk__dragger ".concat(r, " ").concat(i || n);
  return e("div", Object.assign({
    className: g,
    ref: o,
    dir: r,
    onMouseDown: a
  }, {
    children: e("div", {
      className: d
    }, void 0)
  }), void 0);
});
var h, p, f;

function _(e, t, n) {
  var i, r;
  return t ? (i = e / 2, r = e) : n ? (i = e, r = e / 2) : (i = e, r = e), {
    aGutterSize: i,
    bGutterSize: r
  };
}

function z(e, t) {
  switch (t.type) {
    case h.SetIsReadyToCompute:
      return Object.assign(Object.assign({}, e), {
        isReady: t.payload.isReady
      });

    case h.CreatePairs:
      {
        var _t$payload = t.payload,
            _n = _t$payload.direction,
            _i = _t$payload.children,
            _r = _t$payload.gutters,
            _a = _i[0].parentNode;
        if (!_a) throw new Error("Cannot create pairs - parent is undefined.");

        var _o = c(_n, _a);

        if (void 0 === _o) throw new Error("Cannot create pairs - parent has undefined or zero size: ".concat(_o, "."));
        var _g = [];
        return _i.forEach(function (e, t) {
          if (t > 0) {
            var _e = _i[t - 1],
                _o2 = _i[t],
                _d = _r[t - 1],
                _s = _n === p.Horizontal ? _e.getBoundingClientRect().left : _e.getBoundingClientRect().top,
                _c = _n === p.Horizontal ? _o2.getBoundingClientRect().right : _o2.getBoundingClientRect().bottom,
                _l = _n === p.Horizontal ? _e.getBoundingClientRect().width + _d.getBoundingClientRect().width + _o2.getBoundingClientRect().width : _e.getBoundingClientRect().height + _d.getBoundingClientRect().height + _o2.getBoundingClientRect().height,
                _u = _n === p.Horizontal ? _d.getBoundingClientRect().width : _d.getBoundingClientRect().height,
                _h = {
              idx: t - 1,
              a: _e,
              b: _o2,
              gutter: _d,
              parent: _a,
              start: _s,
              end: _c,
              size: _l,
              gutterSize: _u,
              aSizePct: 100 / _i.length,
              bSizePct: 100 / _i.length
            };

            _g.push(_h);
          }
        }), Object.assign(Object.assign({}, e), {
          pairs: _g
        });
      }

    case h.StartDragging:
      {
        var _n2 = t.payload.gutterIdx;
        return Object.assign(Object.assign({}, e), {
          isDragging: !0,
          draggingIdx: _n2
        });
      }

    case h.StopDragging:
      return Object.assign(Object.assign({}, e), {
        isDragging: !1
      });

    case h.CalculateSizes:
      {
        var _t$payload2 = t.payload,
            _n3 = _t$payload2.direction,
            _i2 = _t$payload2.gutterIdx,
            _r2 = e.pairs[_i2],
            _a2 = c(_n3, _r2.parent);

        if (!_a2) throw new Error("Cannot calculate sizes - 'pair.parent' has undefined or zero size.");

        var _o3 = _r2.gutter[_n3 === p.Horizontal ? "clientWidth" : "clientHeight"],
            _g2 = 0 === _i2,
            _d2 = _i2 === e.pairs.length - 1,
            _ref2 = _(_o3, _g2, _d2),
            _s2 = _ref2.aGutterSize,
            _l2 = _ref2.bGutterSize;

        var _u2, _h2, _f, _z, _b;

        return _n3 === p.Horizontal ? (_u2 = _r2.a.getBoundingClientRect().left, _h2 = _r2.b.getBoundingClientRect().right, _z = (_r2.a.getBoundingClientRect().width + _s2) / _a2 * 100, _b = (_r2.b.getBoundingClientRect().width + _l2) / _a2 * 100, _f = _r2.a.getBoundingClientRect().width + _s2 + _l2 + _r2.b.getBoundingClientRect().width) : (_u2 = _r2.a.getBoundingClientRect().top, _h2 = _r2.b.getBoundingClientRect().bottom, _z = (_r2.a.getBoundingClientRect().height + _s2) / _a2 * 100, _b = (_r2.b.getBoundingClientRect().height + _l2) / _a2 * 100, _f = _r2.a.getBoundingClientRect().height + _s2 + _l2 + _r2.b.getBoundingClientRect().height), e.pairs[_i2] = Object.assign(Object.assign({}, _r2), {
          start: _u2,
          end: _h2,
          size: _f,
          aSizePct: _z,
          bSizePct: _b,
          gutterSize: _o3
        }), Object.assign({}, e);
      }

    default:
      return e;
  }
}

function b(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return r.toArray(e).reduce(function (e, i, r) {
    return s(i) ? e.push.apply(e, b(i.props.children, t + 1, n.concat(i.key || r))) : a(i) ? e.push(o(i, {
      key: n.concat(String(i.key)).join(".")
    })) : "string" != typeof i && "number" != typeof i || e.push(i), e;
  }, []);
}

!function (e) {
  e[e.SetIsReadyToCompute = 0] = "SetIsReadyToCompute", e[e.CreatePairs = 1] = "CreatePairs", e[e.CalculateSizes = 2] = "CalculateSizes", e[e.StartDragging = 3] = "StartDragging", e[e.StopDragging = 4] = "StopDragging";
}(h || (h = {})), function (e) {
  e.Horizontal = "Horizontal", e.Vertical = "Vertical";
}(p || (p = {})), function (e) {
  e.Light = "Light", e.Dark = "Dark";
}(f || (f = {}));

function C(e) {
  return e === p.Horizontal ? "col-resize" : "row-resize";
}

var w = {
  isReady: !1,
  isDragging: !1,
  pairs: []
};

function y(_ref3) {
  var _ref3$direction = _ref3.direction,
      r = _ref3$direction === void 0 ? p.Horizontal : _ref3$direction,
      _ref3$minWidths = _ref3.minWidths,
      a = _ref3$minWidths === void 0 ? [] : _ref3$minWidths,
      _ref3$minHeights = _ref3.minHeights,
      o = _ref3$minHeights === void 0 ? [] : _ref3$minHeights,
      s = _ref3.initialSizes,
      _ref3$gutterTheme = _ref3.gutterTheme,
      y = _ref3$gutterTheme === void 0 ? f.Dark : _ref3$gutterTheme,
      S = _ref3.gutterClassName,
      m = _ref3.draggerClassName,
      k = _ref3.children,
      x = _ref3.onResizeStarted,
      R = _ref3.onResizeFinished,
      _ref3$classes = _ref3.classes,
      v = _ref3$classes === void 0 ? [] : _ref3$classes;

  var B = b(k),
      _g3 = g(z, w),
      _g4 = _slicedToArray(_g3, 2),
      I = _g4[0],
      D = _g4[1],
      H = d(null),
      E = d([]),
      j = d([]);

  E.current = [], j.current = [];
  var O = n.useCallback(function (e) {
    D({
      type: h.SetIsReadyToCompute,
      payload: {
        isReady: e
      }
    });
  }, []),
      N = n.useCallback(function (e, t) {
    D({
      type: h.StartDragging,
      payload: {
        gutterIdx: t
      }
    });
    var n = I.pairs[t];
    null == x || x(n.idx), n.a.style.userSelect = "none", n.b.style.userSelect = "none", n.gutter.style.cursor = C(e), n.parent.style.cursor = C(e), document.body.style.cursor = C(e);
  }, [I.pairs]),
      $ = n.useCallback(function () {
    D({
      type: h.StopDragging
    });
    var e = [];

    for (var _t = 0; _t < I.pairs.length; _t++) {
      var _n4 = I.pairs[_t],
          _i3 = c(r, _n4.parent);

      if (void 0 === _i3) throw new Error("Cannot call the 'onResizeFinished' callback - parentSize is undefined");
      if (void 0 === _n4.gutterSize) throw new Error("Cannot call 'onResizeFinished' callback - gutterSize is undefined");

      var _a3 = 0 === _t,
          _o4 = _t === I.pairs.length - 1,
          _g5 = _n4.a.getBoundingClientRect()[r === p.Horizontal ? "width" : "height"],
          _ref4 = _(_n4.gutterSize, _a3, _o4),
          _d3 = _ref4.aGutterSize,
          _s3 = _ref4.bGutterSize,
          _l3 = (_g5 + _d3) / _i3 * 100;

      if (e.push(_l3), _o4) {
        var _t2 = (_n4.b.getBoundingClientRect()[r === p.Horizontal ? "width" : "height"] + _s3) / _i3 * 100;

        e.push(_t2);
      }
    }

    if (void 0 === I.draggingIdx) throw new Error("Could not reset cursor and user-select because 'state.draggingIdx' is undefined");
    var t = I.pairs[I.draggingIdx];
    null == R || R(t.idx, e), t.a.style.userSelect = "", t.b.style.userSelect = "", t.gutter.style.cursor = "", t.parent.style.cursor = "", document.body.style.cursor = "";
  }, [I.draggingIdx, I.pairs, r]),
      F = n.useCallback(function (e, t) {
    D({
      type: h.CalculateSizes,
      payload: {
        direction: e,
        gutterIdx: t
      }
    });
  }, []),
      G = n.useCallback(function (e, t, n) {
    D({
      type: h.CreatePairs,
      payload: {
        direction: e,
        children: t,
        gutters: n
      }
    });
  }, []),
      P = n.useCallback(function (e, t, n, i) {
    var r = t[0].parentNode;
    if (!r) throw new Error("Cannot set initial sizes - parent is undefined");
    if (void 0 === c(e, r)) throw new Error("Cannot set initial sizes - parent has undefined size");
    t.forEach(function (r, a) {
      var o = a === t.length - 1;
      var g;

      if (t.length > 1) {
        n[o ? a - 1 : a].getBoundingClientRect()[e === p.Horizontal ? "width" : "height"];
      }

      g = i && a < i.length ? "calc(".concat(i[a], "% - 0px)") : "calc(".concat(100 / t.length, "% - 0px)"), e === p.Horizontal ? (r.style.width = g, r.style.height = "100%") : (r.style.height = g, r.style.width = "100%");
    });
  }, []),
      T = n.useCallback(function (e, t) {
    if (void 0 === I.draggingIdx) throw new Error("Cannot adjust size - 'draggingIdx' is undefined");
    var n = I.pairs[I.draggingIdx];
    if (void 0 === n.size) throw new Error("Cannot adjust size - 'pair.size' is undefined");
    if (void 0 === n.gutterSize) throw new Error("Cannot adjust size - 'pair.gutterSize' is undefined");

    var i = n.aSizePct + n.bSizePct,
        r = t / n.size * i,
        a = i - t / n.size * i,
        o = 0 === I.draggingIdx,
        g = I.draggingIdx === I.pairs.length - 1,
        _ref5 = _(n.gutterSize, o, g),
        d = _ref5.aGutterSize,
        s = _ref5.bGutterSize,
        c = "calc(".concat(r, "% - ").concat(d, "px)"),
        l = "calc(".concat(a, "% - ").concat(s, "px)");

    e === p.Horizontal ? (n.a.style.width = c, n.b.style.width = l) : (n.a.style.height = c, n.b.style.height = l);
  }, [I.draggingIdx, I.pairs, r]),
      L = n.useCallback(function (e, t, n) {
    if (!I.isDragging) return;
    if (void 0 === I.draggingIdx) throw new Error("Cannot drag - 'draggingIdx' is undefined");
    var i = I.pairs[I.draggingIdx];
    if (void 0 === i.start) throw new Error("Cannot drag - 'pair.start' is undefined");
    if (void 0 === i.size) throw new Error("Cannot drag - 'pair.size' is undefined");
    if (void 0 === i.gutterSize) throw new Error("Cannot drag - 'pair.gutterSize' is undefined");

    var r = function (e, t) {
      return e === p.Horizontal ? t.clientX : t.clientY;
    }(t, e) - i.start,
        a = 16,
        o = 16;

    n.length > I.draggingIdx && (a = n[I.draggingIdx]), n.length >= I.draggingIdx + 1 && (o = n[I.draggingIdx + 1]), r < i.gutterSize + a && (r = i.gutterSize + a), r >= i.size - (i.gutterSize + o) && (r = i.size - (i.gutterSize + o)), T(t, r);
  }, [I.isDragging, I.draggingIdx, I.pairs, T]);

  function V(e, t) {
    if (!e.current) throw new Error("Can't add element to ref object - ref isn't initialized");
    t && !e.current.includes(t) && e.current.push(t);
  }

  return l("mouseup", function () {
    if (I.isDragging) {
      if (void 0 === I.draggingIdx) throw new Error("Cannot calculate sizes after dragging = 'state.draggingIdx' is undefined");
      F(r, I.draggingIdx), $();
    }
  }, [I.isDragging, $]), l("mousemove", function (e) {
    I.isDragging && L(e, r, r === p.Horizontal ? a : o);
  }, [r, I.isDragging, L, a, o]), i(function () {
    if (!H.current) return;
    var e = H.current.parentElement;
    if (!e) return;
    var t = new ResizeObserver(function () {
      var t = getComputedStyle(e),
          n = r === p.Horizontal ? e.clientWidth : e.clientHeight;
      O(!!t && !!n);
    });
    return t.observe(e), function () {
      t.disconnect();
    };
  }, [H.current, r]), i(function () {
    if (I.isReady) {
      if (!E.current || !j.current) throw new Error("Cannot create pairs - either variable 'childRefs' or 'gutterRefs' is undefined");
      B.length <= 1 ? P(r, E.current, j.current, s) : (P(r, E.current, j.current, s), G(r, E.current, j.current));
    }
  }, [k, I.isReady, r, P, G, s]), e("div", Object.assign({
    className: "__dbk__container ".concat(r),
    ref: H
  }, {
    children: I.isReady && B.map(function (i, a) {
      return t(n.Fragment, {
        children: [e("div", Object.assign({
          ref: function ref(e) {
            return V(E, e);
          },
          className: "__dbk__child-wrapper " + (a < v.length ? v[a] : "")
        }, {
          children: i
        }), void 0), a < B.length - 1 && e(u, {
          ref: function ref(e) {
            return V(j, e);
          },
          className: S,
          theme: y,
          draggerClassName: m,
          direction: r,
          onMouseDown: function onMouseDown(e) {
            return function (e, t) {
              t.preventDefault(), F(r, e), N(r, e);
            }(a, e);
          }
        }, void 0)]
      }, a);
    })
  }), void 0);
}

export { f as GutterTheme, p as SplitDirection, y as default };